export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-white mb-3">
                移动吃瓜，随时随地
              </h2>
              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                关注51吃瓜微信公众号和小程序，随时随地获取最新大瓜推送。地铁上、午休时、睡觉前，吃瓜从不错过任何精彩瞬间。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-primary-500 rounded-full font-medium text-sm hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="ri-wechat-line text-lg"></i>
                  关注公众号
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-5 py-2.5 border border-white/40 text-white rounded-full font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="ri-smartphone-line text-lg"></i>
                  了解更多
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 h-72 md:w-56 md:h-80 rounded-2xl overflow-hidden border-4 border-white/30 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20interface%20mockup%20showing%20entertainment%20news%20feed%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20Chinese%20language%20UI%20design%2C%20clean%20card%20layout%20with%20thumbnails%2C%20minimalist%20mobile%20app%20screen%2C%20soft%20shadows%2C%20editorial%20style&width=450&height=720&seq=app-mockup-screen&orientation=portrait"
                  alt="51吃瓜移动端界面预览，随时随地在线吃瓜"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}